import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import List from './List'
import New from './New'
import Edit from './Edit'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_RELEASE_NOTES } from 'app-support/permissions/Permissions'
import { releaseNotesRoute, releaseNotesRouteEdit, releaseNotesRouteNew } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(releaseNotesRoute)

const ReleaseNotesContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_RELEASE_NOTES} exact path={releaseNotesRoute} component={List} />
    <PermissionRoute permission={PERMISSION_RELEASE_NOTES} exact path={releaseNotesRouteNew} component={New} />
    <PermissionRoute permission={PERMISSION_RELEASE_NOTES} exact path={releaseNotesRouteEdit} component={Edit} />
  </Switch>
)

export default enhance(ReleaseNotesContainer)
